import { ApiClientBase } from "./ApiClientBase";

export interface TelegramBinding {
    telegramUserId: number;
    dpaInstanceIdentifier: string;
}

class TelegramService extends ApiClientBase {
    constructor() {
        super("/api/Telegram/");
    }

    public Binding(): Promise<TelegramBinding[]> {
        return this.get("Binding");
    }
}

export const telegramService = new TelegramService();
